<!-- Logo Navbar header Start -->
<app-header></app-header>

<div class="main-container">
  <app-public-rounded-container>

    <div class="border-bottom text-center">
      <h3 class="card-title ">{{ 'Sellers.Products.ChangePassword' | translate }}</h3>
      <p>{{ 'Sellers.Products.ChangePasswordDesc' | translate }}</p>
    </div>
    <div class="row align-items-center card-body mx-2">
      <form #f="ngForm" class="login-form" [formGroup]="changePasswordForm" *ngIf="changePasswordForm">
        <div class="col-md-12 mb-3">
          <!-- <label>{{ 'Sellers.Products.OldPassword' | translate }}</label> -->
          <div class="input-group">
            <input class="form-control" type="password" placeholder="{{ 'Sellers.Products.EnterPassword' | translate }}"
              formControlName="old_password" [type]="oldPasswordHide ? 'password' : 'text'" data-toggle="password">
            <div class="input-group-append">
              <span (click)="oldPasswordHide = !oldPasswordHide" class="input-group-text py-3">
                <i class="fa fa-eye"></i>
              </span>
            </div>
          </div>
          <small class="text-danger" *ngIf="formValidator.formErrors.old_password">
            {{ formValidator.formErrors.old_password }}
          </small>
        </div>
        <div class="col-md-12 mb-3">
          <!-- <label>{{ 'Sellers.Products.NewPassword' | translate }}</label> -->
          <div class="input-group">
            <input class="form-control" type="password" placeholder="{{ 'Sellers.Products.NewPassword' | translate }}"
              data-toggle="password" formControlName="new_password" [type]="newPasswordHide ? 'password' : 'text'">
            <div class="input-group-append">
              <span (click)="newPasswordHide = !newPasswordHide" class="input-group-text py-3">
                <i class="fa fa-eye"></i>
              </span>
            </div>
          </div>
          <small class="text-danger" *ngIf="formValidator.formErrors.new_password">
            {{ formValidator.formErrors.new_password }}
          </small>
        </div>
        <div class="col-md-12 mb-3">
          <!-- <label>{{ 'Sellers.Products.ConfirmPassword' | translate }}</label> -->
          <div class="input-group">
            <input class="form-control" type="password"
              placeholder="{{ 'Sellers.Products.ConfirmPassword' | translate }}" formControlName="confirm_new_password"
              [type]="confirmNewPasswordHide ? 'password' : 'text'" data-toggle="password">
            <div class="input-group-append">
              <span (click)="confirmNewPasswordHide = !confirmNewPasswordHide" class="input-group-text py-3">
                <i class="fa fa-eye"></i>
              </span>
            </div>
          </div>
          <small class="text-danger" *ngIf="formValidator.formErrors.confirm_new_password">
            {{ formValidator.formErrors.confirm_new_password }}
          </small>
        </div>
        <div class="col-md-12 mb-3">
          <label class="form-label mb-2 "> {{ 'Sellers.Products.EnterOtp' | translate }}</label>
          <!-- <label>{{ 'Sellers.Products.EnterOtp' | translate }}</label> -->
          <div class="input-group">
            <input class="form-control" type="text" placeholder="{{ 'Sellers.Products.EnterOtp' | translate }}"
              formControlName="otp" data-toggle="otp">
          </div>
          <small class="text-danger" *ngIf="formValidator.formErrors.otp">
            {{ formValidator.formErrors.otp }}
          </small>
        </div>
        <button class="col-12 btn btn-primary mb-2 " type="button" [disabled]='changePasswordForm.invalid'
          (click)="submit()">
          {{ 'Sellers.Products.Change' | translate }}
        </button>
        <button class="col-12 btn btn-success" [disabled]="sendCodeClicked" (click)="reSend()">{{
          "Sellers.Products.Resend" | translate }}
          <ng-container *ngIf="sendCodeClicked">
            ({{ timer | async }})
          </ng-container>
        </button>
      </form>
    </div>

  </app-public-rounded-container>
